import { render, staticRenderFns } from "./ListStudentPreview.vue?vue&type=template&id=203b61bf&scoped=true&"
import script from "./ListStudentPreview.vue?vue&type=script&lang=js&"
export * from "./ListStudentPreview.vue?vue&type=script&lang=js&"
import style0 from "./ListStudentPreview.vue?vue&type=style&index=0&id=203b61bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b61bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
